import { render, staticRenderFns } from "./PriceRangeConflict.vue?vue&type=template&id=4b648754&scoped=true&"
import script from "./PriceRangeConflict.vue?vue&type=script&lang=js&"
export * from "./PriceRangeConflict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b648754",
  null
  
)

export default component.exports